import { Button } from '@civilgrid/ui/components';
import { capturePosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import type { ProjectWithDetails } from '../common';
import store from './store';

export default function EditGeometryButton({ project }: { project: ProjectWithDetails }) {
  const onClick = () => {
    store.setIsEditingProject(true);

    capturePosthogEvent(POSTHOG_EVENTS.projectBoundaryEditViewed, {
      project_id: project.id,
      organization_id: project.organization || undefined,
    });
  };

  return (
    <Button variant="secondary" onClick={onClick} data-testid="project-details-edit-boundary">
      Edit Project Boundary
    </Button>
  );
}
